import React from 'react';
import { motion } from 'framer-motion';
import { Users, ShieldCheck, Activity, Zap, MessageSquare, Heart } from 'lucide-react';
const ingredients = [{
  icon: Users,
  label: 'People'
}, {
  icon: ShieldCheck,
  label: 'Leadership'
}, {
  icon: Activity,
  label: 'Science'
}, {
  icon: Zap,
  label: 'Energy'
}, {
  icon: MessageSquare,
  label: 'Real Stories'
}, {
  icon: Heart,
  label: 'Authentic Emotion'
}];
export const Slide02Moment = () => {
  return <div className="relative w-full h-full flex flex-col justify-center px-24 bg-slate-950 overflow-hidden" data-id="element-43">
      <div className="absolute inset-0 bg-gradient-to-br from-slate-950 via-slate-900 to-red-950/20" data-id="element-44" />

      <div className="relative z-10 grid grid-cols-12 gap-16 items-center" data-id="element-45">
        <div className="col-span-5" data-id="element-46">
          <motion.h2 initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.2,
          duration: 0.8
        }} className="text-5xl font-bold tracking-tight mb-6 text-white leading-tight" data-id="element-47">
            Start with the <br data-id="element-48" />
            <span className="text-red-500" data-id="element-49">perfect moment.</span>
          </motion.h2>

          <motion.p initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.3,
          duration: 0.8
        }} className="text-xl text-slate-300 font-light leading-relaxed mb-8" data-id="element-50">
            ERA already contains the ingredients. Instead of inventing
            engagement, we capture existing momentum.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4,
          duration: 0.8
        }} className="p-6 bg-slate-900/50 border border-slate-800 rounded-xl backdrop-blur-sm" data-id="element-51">
            <p className="text-lg text-slate-200 font-medium italic" data-id="element-52">
              "The goal is not a full transformation today. The goal is to
              launch a fast pilot that captures authentic energy from ERA."
            </p>
          </motion.div>
        </div>

        <div className="col-span-7" data-id="element-53">
          <div className="grid grid-cols-3 gap-6" data-id="element-54">
            {ingredients.map((item, index) => <motion.div key={item.label} initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            delay: 0.2 + index * 0.1,
            duration: 0.5
          }} className="group relative aspect-square flex flex-col items-center justify-center p-6 bg-slate-900/40 border border-slate-800/60 rounded-2xl hover:bg-slate-800/60 hover:border-red-500/50 transition-all duration-500" data-id="element-55">
                <div className="absolute inset-0 bg-gradient-to-br from-red-500/0 to-red-500/0 group-hover:from-red-500/10 group-hover:to-transparent rounded-2xl transition-all duration-500" data-id="element-56" />
                <item.icon className="w-10 h-10 text-red-500 mb-4 group-hover:scale-110 transition-transform duration-500" strokeWidth={1.5} data-id="element-57" />
                <span className="text-slate-200 font-medium text-center" data-id="element-58">
                  {item.label}
                </span>
              </motion.div>)}
          </div>
        </div>
      </div>
    </div>;
};